import { InfoCell } from '@/components/shared/InfoCell';
import { EMPLOYEE_DETAILS_COLUMN_WIDTH, EMPLOYEE_NAME_COLUMN_WIDTH } from '@/helpers/constants';
import { secondsToTimeString } from '@/helpers/dateHelper';
import { useSystemSettings } from '@/services/settings/SystemSettingsProvider';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { useHourSummary } from './hooks/useHourSummary';
import { useRosterEmployeesSummary, useWorkingRoster } from './providers/WorkingRosterService';
import { ShiftHourSummary } from './ShiftHourSummary';

interface RosterHourSummaryProps {}

export const RosterHourSummary: FC<RosterHourSummaryProps> = ({}) => {
  const { workingRoster } = useWorkingRoster();

  if (!workingRoster) {
    throw Error('Working template should be defined');
  }

  const minuteIncrement = useSystemSettings(state => state.settings.minuteIncrement);
  const secondIncrement = minuteIncrement * 60;

  const counts = useHourSummary([...workingRoster.shifts], workingRoster.startTime, workingRoster.endTime, true);

  const monthly = useRosterEmployeesSummary(
    workingRoster.shifts.map(shift => shift.assignedEmployeeId).filter(Boolean) as string[]
  );

  const totalMonthly = monthly
    ? monthly.filter(m => m.homeEmployee).reduce((sum, m) => sum + (m.compliance?.actualTime ?? 0), 0)
    : 0;

  const countTotal = counts.reduce((prevTot, currVal) => prevTot + currVal, 0);

  return (
    <div className="flex flex-row">
      <div
        className="flex border-b border-r px-3 items-center justify-end font-bold"
        style={{ width: EMPLOYEE_NAME_COLUMN_WIDTH }}
      >
        {strings.daily.summary.totalActualEmployee}
      </div>
      <div className="flex border-b bg-background-mid" style={{ width: EMPLOYEE_DETAILS_COLUMN_WIDTH }}>
        <div className="flex flex-1 border-r">
          <InfoCell>{secondsToTimeString(totalMonthly)}</InfoCell>
        </div>
        <div className="flex flex-1">
          <InfoCell className="border-r">{secondsToTimeString(countTotal)}</InfoCell>
        </div>
      </div>

      <ShiftHourSummary counts={counts} />
    </div>
  );
};
